import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import { AWS_PROFILE_IMAGES_URL } from "constants";
import Tip from "components/other/Tip";

import bronzeCheckmarkIcon from "assets/img/icons/checkmark-bronze.svg";
import silverCheckmarkIcon from "assets/img/icons/checkmark-silver.svg";
import goldCheckmarkIcon from "assets/img/icons/checkmark-gold.svg";
import newTabIcon from "assets/img/icons/Expand-Window.svg";

const SponsoredMessage = styled.div`
  padding: 13px 20px 15px;
  box-sizing: border-box;

  background: ${(props) =>
    props.listbox ? "#3c556c" : css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchMobile}) {
    padding: 13px 15px 15px;
  }
`;

const ProfileLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap-reverse;
`;

const ProfileWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

const AvatarIcon = styled.div`
  padding: 0px 0;

  width: 30px;
  min-width: 30px;
  height: 30px;
  background-image: ${(props) => `url(${props.image})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;

  overflow: hidden;
`;

const Username = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
`;

const UsernameBox = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const CheckmarkIcon = styled.div`
  width: 18px;
  min-width: 18px;
  height: 18px;
`;

const TitleBox = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const SponsoredMessageTitle = styled.div`
  padding: 3px 1px 2px;

  font-size: 11px;
  font-weight: 500;
  line-height: 1;
`;

const MessageLine = styled.div`
  margin-top: 4px;

  display: flex;
  align-items: center;
  gap: 2px;

  @media (max-width: ${globalConstants.switchMobile}) {
    margin-top: 3px;
  }
`;

const Message = styled.div`
  line-height: 130%;
`;

const MessageLink = styled.a`
  color: ${css.LIGHT_BLUE};
  font-weight: 400;
  text-decoration: none;

  &:hover {
    cursor: pointer;
  }
`;

const NewTabIcon = styled.div`
  padding-left: 3px;
  width: 11px;
  min-width: 11px;
  transform: translateY(1px);

  display: inline-block;
`;

export default ({
  profileImage,
  username,
  checkmark,
  text,
  linkText,
  link,
  listBox,
  onLinkClick,
}) => {
  let planIcon = goldCheckmarkIcon;

  switch (checkmark) {
    case 1:
      planIcon = bronzeCheckmarkIcon;
      break;
    case 2:
      planIcon = silverCheckmarkIcon;
      break;
  }

  return (
    <SponsoredMessage listbox={listBox ? 1 : 0}>
      <ProfileLine>
        <ProfileWrap>
          <AvatarIcon image={AWS_PROFILE_IMAGES_URL + profileImage}>
            {/* <img
              src={AWS_PROFILE_IMAGES_URL + profileImage}
              style={{ width: "100%", borderRadius: "50%" }}
            /> */}
          </AvatarIcon>
          <UsernameBox>
            <Username>{username}</Username>
            {checkmark && (
              <CheckmarkIcon>
                <img src={planIcon} style={{ width: "100%" }} />
              </CheckmarkIcon>
            )}
          </UsernameBox>
        </ProfileWrap>
        <TitleBox>
          <SponsoredMessageTitle>SPONSORED MESSAGE</SponsoredMessageTitle>
          <Tip
            tipId="sponsoredMessage"
            tip="To place your message here, subscribe for the Gold advertising plan."
            size="16px"
          />
        </TitleBox>
      </ProfileLine>
      <MessageLine>
        <Message>
          {text.length > 0 ? text : "Your message will appear here."}{" "}
          <MessageLink href={link} target="_blank" onClick={onLinkClick}>
            {linkText}
            {linkText && (
              <NewTabIcon>
                <img src={newTabIcon} style={{ width: "100%" }} />
              </NewTabIcon>
            )}
          </MessageLink>
        </Message>
      </MessageLine>
    </SponsoredMessage>
  );
};
